import script from "./SelectedBonusesDisplay2.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedBonusesDisplay2.vue?vue&type=script&setup=true&lang=ts"

import "./SelectedBonusesDisplay2.vue?vue&type=style&index=0&id=2c9ff138&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9ff138"]])

export default __exports__